module.exports = __webpack_public_path__ + "img/highlight-icon1.9632828b.png";